import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Image } from 'shared/components/Image';
import { isFunction } from 'lodash';

import { IProductTemplate } from 'shared/types/ProductTemplate';
import { variableFontRegular } from 'styles/theme';
import { toggleVisible } from 'styles/theme/animation';

interface IProductTemplateImageGridProps {
  align: 'left' | 'center' | 'right';
  disableLazyLoad?: boolean;
  isCrawler?: boolean;
  imageSize?: string;
  onClick?: () => void;
  product: IProductTemplate;
  missingAssetPath?: string;
}

export const ProductTemplateImageGrid = ({
  align,
  imageSize = '150px',
  isCrawler = false,
  onClick,
  product,
  disableLazyLoad = true,
  missingAssetPath,
}: IProductTemplateImageGridProps) => {
  const handleOnClick = () => {
    if (isFunction(onClick)) {
      onClick();
    }
  };

  return (
    <ProductTemplateImageGrid.Wrapper>
      <Link
        href={`/${product.productCategory === 'shoes' ? 'sneakers' : 'apparel'}/${product.slug}`}
        passHref
        prefetch={false}
      >
        <ProductTemplateImageGrid.Link onClick={handleOnClick}>
          {isCrawler ? (
            product?.name
          ) : (
            <Image
              alt={product.name}
              data-qa="product_template_grid_image"
              disableLazyLoad={disableLazyLoad}
              sizes={imageSize}
              src={product.gridPictureUrl}
              missingAssetPath={missingAssetPath}
            />
          )}
        </ProductTemplateImageGrid.Link>
      </Link>
      <ProductTemplateImageGrid.Name align={align} data-qa="product_template_grid_name">
        {product.name}
      </ProductTemplateImageGrid.Name>
    </ProductTemplateImageGrid.Wrapper>
  );
};

ProductTemplateImageGrid.Wrapper = styled.div`
  position: relative;
  height: 100%;
`;

ProductTemplateImageGrid.Link = styled.a`
  display: block;
`;

ProductTemplateImageGrid.Name = styled.div<{ align?: IProductTemplateImageGridProps['align'] }>`
  position: absolute;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  ${variableFontRegular({ size: '9.5px', height: '10px' })};
  visibility: hidden;
  opacity: 0;

  @media (hover: hover) and (pointer: fine) {
    a:hover ~ & {
      ${toggleVisible};
    }
  }

  ${({ align }) => {
    if (align === 'center') {
      return css`
        left: 50%;
        transform: translateX(-50%);
      `;
    }

    if (align === 'right') {
      return css`
        right: 0;
      `;
    }

    return css`
      left: 0;
    `;
  }};
`;
